import { useState } from 'react'
import { useSelector } from 'react-redux'

import { getFooter } from 'store/footer/selectors'
import { getFooterMenus } from 'store/menus/selectors'
import emailOfTheDayApi from 'services/email-of-the-day'
import Footer from 'ui-component-library/components/Footer'

function FooterContainer() {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const { emailOfTheDay, ...footer } = useSelector(getFooter)
  const footerMenus = useSelector(getFooterMenus)

  async function handleSubmitEmail(email: string) {
    if (isSubmitting) {
      return
    }

    setIsSubmitting(true)

    try {
      await emailOfTheDayApi.submit(email)
    } catch (error) {
      setIsSubmitting(false)
      throw error
    }
  }

  return (
    <Footer
      {...footer}
      {...footerMenus}
      emailOfTheDay={{
        ...emailOfTheDay,
        onSubmitEmail: handleSubmitEmail,
      }}
    />
  )
}

export default FooterContainer
